export default {
  VENDOR: 'Vendor',
  CUSTOMER: 'Customer',
  BROKER: 'Broker',
  GROWER: 'Grower',
  DISTRIBUTOR: 'Distributor',
  CARRIER: 'Carrier',
  GOVERNMENT: 'Government Entity',
  THIRD_PARTY_LOGISTICS: 'Third-Party Logistics Provider',
  AGENTS: 'Agent',
  FINANCIAL_INSTITUTION: 'Financial Institution',
  INSURER: 'Insurer',
  CERTIFICATION_BODY: 'Certification Body',
  SERVICE_PROVIDER: 'Service Provider',
};
